import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { AuthContext } from './AuthContext';
import {urlApi} from  '../configuracion/serverConfig';
import { toast } from 'react-toastify';

const POLL_INTERVAL_MS = 10000;

const verificarSesion = (sesionId, usuario) =>
    fetch(`${urlApi}/usuario/login/${sesionId}/${usuario}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: 'application/json'
        }
    })
    .then(res => res.json())
    .catch(() => null);

const AuthProvider = (props) => {

    const [auth, setAuth] = useState(undefined);
    const [sesionExpirada, setSesionExpirada] = useState({ visible: false, mensaje: '' });
    const intervalRef = useRef(null);
    const yaDetectadaRef = useRef(false);

    const invalidarSesion = () => {
        sessionStorage.removeItem('Usuario');
        setAuth(false);
    };

    const mostrarAlertaSesion = (mensaje) => {
        if (yaDetectadaRef.current) return;
        yaDetectadaRef.current = true;
        clearInterval(intervalRef.current);
        setSesionExpirada({ visible: true, mensaje: mensaje || 'La sesión ha expirado.' });
    };

    const mostrarAlertaSesionRef = useRef(mostrarAlertaSesion);

    const confirmarSesionExpirada = () => {
        yaDetectadaRef.current = false;
        setSesionExpirada({ visible: false, mensaje: '' });
        invalidarSesion();
    };

    useEffect(() => {
        const objSesion = JSON.parse(sessionStorage.getItem('Usuario'));
        if (objSesion !== null && objSesion.hasOwnProperty("sesionId") && objSesion.hasOwnProperty("usuario")) {
            verificarSesion(objSesion.sesionId, objSesion.usuario).then(data => {
                if (data && data.status === 0) {
                    setAuth(true);
                } else {
                    invalidarSesion();
                    if (data?.objError?.msgError) toast.info(data.objError.msgError);
                }
            });
        } else {
            setAuth(false);
        }
    }, []);

    useEffect(() => {
        mostrarAlertaSesionRef.current = mostrarAlertaSesion;
    });

    useEffect(() => {
        if (auth !== true) return;

        intervalRef.current = setInterval(() => {
            const objSesion = JSON.parse(sessionStorage.getItem('Usuario'));
            if (!objSesion) {
                clearInterval(intervalRef.current);
                return;
            }
            verificarSesion(objSesion.sesionId, objSesion.usuario).then(data => {
                if (!data || data.status !== 0) {
                    mostrarAlertaSesionRef.current(data?.objError?.msgError);
                }
            });
        }, POLL_INTERVAL_MS);

        return () => clearInterval(intervalRef.current);
    }, [auth]);

    useEffect(() => {
        if (auth !== true) return;

        const originalFetch = window.fetch;
        window.fetch = async (...args) => {
            const response = await originalFetch(...args);
            const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
            if (url.startsWith(urlApi)) {
                response.clone().json().then(data => {
                    if (data?.status === 1 && data?.objError?.msgError) {
                        const msg = data.objError.msgError.toLowerCase();
                        if (msg.includes('sesi')) {
                            mostrarAlertaSesionRef.current(data.objError.msgError);
                        }
                    }
                }).catch(() => {});
            }
            return response;
        };

        return () => { window.fetch = originalFetch; };
    }, [auth]);


    if(auth === undefined) return null;

        return (
            <>
            <AuthContext.Provider value={[auth, setAuth]}>
                {props.children}
            </AuthContext.Provider>
            <Modal isOpen={sesionExpirada.visible} centered backdrop="static" keyboard={false}>
                <ModalHeader>Sesión expirada</ModalHeader>
                <ModalBody>{sesionExpirada.mensaje}</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmarSesionExpirada}>Aceptar</Button>
                </ModalFooter>
            </Modal>
            </>
        );
    
    
}

export default AuthProvider;

